import _export from '../internals/export.js';
import createHtml from '../internals/create-html.js';
import stringHtmlForced from '../internals/string-html-forced.js';

var $ = _export;
var createHTML = createHtml;
var forcedStringHTMLMethod = stringHtmlForced; // `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link

$({
  target: 'String',
  proto: true,
  forced: forcedStringHTMLMethod('link')
}, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});
